import { withProfiling } from '../../../self-measurements';
export var generateSpanId = withProfiling(function generateSpanId() {
  return Array.from(new Array(16), function () {
    return Math.floor(Math.random() * 16).toString(16);
  }).join('');
});